import { Disclosure, Transition } from '@headlessui/react';
import React from 'react';
import ToggleInput from '../components/inputs/ToggleInput';
import FormLabel from '../components/basicComponents/FormLabel';
import InputFactory from '../components/inputs/InputFactory';
import { getText } from '../utils/functions';

const defaultTransition = {
	enter: 'transition duration-1000 ease-in-out',
	enterFrom: 'transform opacity-0',
	enterTo: 'transform opacity-100',
	leave: 'transition duration-600 ease-in-out',
	leaveFrom: 'transform opacity-100',
	leaveTo: 'transform opacity-0',
};

/*
* Main function
*/
function InterventionsForm({
	portal,
	formData,
	setFormData,
	colors,
	translate,

	/* OPTIONAL PROPS */
	isOptional,
	styleTransition,
	classNameDIV = 'space-y-5',
	classNameBTN = 'flex font-lato space-x-4 items-center w-full',
}) {
	/* Default values for the styles */
	const defaultStyleBTN = {
		color: colors?.text,
	};

	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideTransition = { ...defaultTransition, ...styleTransition };

	/* Resets the votes to an empty array */
	const resetVotes = () => setFormData({ ...formData, votes: [] });

	/* If portal changes, we reset the votes */
	React.useEffect(() => {
		resetVotes();
	}, [portal]);

	if (!isOptional) {
		return <div as='div' className={classNameDIV}>
			<div className={classNameBTN} style={defaultStyleBTN}>
				<FormLabel
					text={portal?.config?.forms?.intervention}
					colors={colors}
					translate={translate}
				/>
			</div>
			<InputFactory
				portal={portal}
				inputConfig={portal.config.forms.interventionTextarea}
				showLabel={getText(portal.config.forms.interventionTextarea, translate)}
				formData={formData}
				value={formData.intervention}
				setFormData={setFormData}
				personType={'person'}
				colors={colors}
				translate={translate}
			/>
		</div>;
	}

	return <Disclosure as='div' className={classNameDIV}>
		{({ open }) => (
			<>
				<div className={classNameBTN} style={defaultStyleBTN}>
					<FormLabel
						text={portal?.config?.forms?.intervention}
						colors={colors}
						translate={translate}
					/>
					<Disclosure.Button as='div'>
						<ToggleInput value={open} colors={colors} />
					</Disclosure.Button>
				</div>
				<Transition
					enter={overrideTransition.enter}
					enterFrom={overrideTransition.enterFrom}
					enterTo={overrideTransition.enterTo}
					leave={overrideTransition.leave}
					leaveFrom={overrideTransition.leaveFrom}
					leaveTo={overrideTransition.leaveTo}
				>

					<Disclosure.Panel>
						<InputFactory
							portal={portal}
							inputConfig={portal.config.forms.interventionTextarea}
							showLabel={getText(portal.config.forms.interventionTextarea, translate)}
							formData={formData}
							value={formData.intervention}
							setFormData={setFormData}
							personType={'person'}
							colors={colors}
							translate={translate}
						/>
					</Disclosure.Panel>
				</Transition>
			</>
		)}
	</Disclosure>;
}

export default InterventionsForm;
